"use client"

import { type ReactNode } from "react"
import Link from "next/link"
import * as Sentry from "@sentry/react"
import { initSentry } from "@/lib/sentry"

// Initialize once when the module loads in the browser
initSentry()

function SentryFallback({ resetError }: { error: unknown; resetError: () => void }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-[var(--bg-page)]">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold text-[var(--text-primary)] mb-3">
          Something went wrong
        </h1>
        <p className="text-sm text-[var(--text-muted)] mb-6">
          An unexpected error occurred. Our team has been notified.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={resetError}
            className="rounded-lg border border-[var(--border-default)] bg-white px-5 py-2.5 text-sm font-medium text-[var(--text-secondary)] transition-colors hover:border-[var(--gold)] hover:text-[var(--text-primary)]"
          >
            Try Again
          </button>
          <Link
            href="/"
            className="btn-gold rounded-lg px-5 py-2.5 text-sm font-medium transition-all"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export function SentryProvider({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={SentryFallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
